import useApi from "../useApi";

interface UseGetFormGroupInterface {
  deleteById: (id: string) => Promise<boolean>;
}

const useDeleteFormGroup = (): UseGetFormGroupInterface => {
  const { deleteRequest } = useApi();

  const deleteById = async (id: string): Promise<boolean> => {
    const { status } = await deleteRequest(`/form-group/${id}`);

    if (status !== 200) {
      // todo
      throw new Error("Unknown");
    }

    return true;
  };

  return { deleteById };
};

export default useDeleteFormGroup;
